// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","copyright":"Footer_copyright__2OWH4"};